import { useEffect, useState } from "react";
import { AgGridReact } from "ag-grid-react";
import SystemSettingsModal from "./modals/SystemSettingsModal";
import { getSystemSettings } from "../services/adminPanel_service";
import editIcon from "../../../assets/images/grid_edit.gif";

const SystemSettingsTab = () => {

  const [rowData, setRowData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);

  const fetchSystemSettings = async () => {
    try {
      const response = await getSystemSettings();
      setRowData(response.data);
    }
    catch {
      setRowData([]);
    }
  };

  useEffect(() => {
    fetchSystemSettings();
  }, []);

  const handleEdit = (row) => {
    setSelectedRow(row);
    setShowModal(true);
  };

  const ActionRenderer = (params) => {

    const row = params.data;

    return (
      <div style={{ display: "flex", gap: "8px" }}>
        <img
          src={editIcon}
          alt="Edit"
          title="Update System Settings"
          style={{ cursor: "pointer", width: "16px" }}
          onClick={() => handleEdit(row)}
        />
      </div>
    );
  };

  const columnDefs = [
    {
      headerName: "Key Name",
      field: "keyName",
      flex: 1
    },
    {
      headerName: "Value",
      field: "value",
      flex: 2
    },
    {
      headerName: "",
      field: "actions",
      cellRenderer: ActionRenderer,
      sortable: false,
      filter: false,
      maxWidth: 80
    }
  ];

  return (
    <>
      <div className="row" style={{marginTop:'10px'}}>

        <section className="col-md-12">

          <div
            className="ag-theme-alpine"
            style={{ height: 500, width: "100%" }}
          >
            <AgGridReact
              theme={"legacy"}
              rowData={rowData}
              columnDefs={columnDefs}
              pagination={true}
              animateRows={true}
            />
          </div>

        </section>

      </div>

      {showModal && (
        <SystemSettingsModal
          show={showModal}
          initialData={selectedRow}
          onClose={() => setShowModal(false)}
          dataReload={fetchSystemSettings}
        />
      )}

    </>
  );
};

export default SystemSettingsTab;